import apiClient from '../client';
import type { User, PaginatedResponse } from '../../types';

interface StaffFilters {
  page?: number;
  size?: number;
  role?: string;
}

const staffService = {
  getMe: async () => {
    const response = await apiClient.get<User>('/staff/me');
    return response.data;
  },

  getStaff: async (filters: StaffFilters = {}) => {
    const { page = 0, size = 20, role } = filters;
    const params = new URLSearchParams({ page: page.toString(), size: size.toString() });
    if (role) params.append('role', role);
    const response = await apiClient.get<PaginatedResponse<User>>(`/staff?${params.toString()}`);
    return response.data;
  },

  getStaffById: async (id: string) => {
    const response = await apiClient.get<User>(`/staff/${id}`);
    return response.data;
  },

  createStaff: async (data: Partial<User>) => {
    const response = await apiClient.post<User>('/staff', data);
    return response.data;
  },

  updateStaff: async (id: string, data: Partial<User>) => {
    const response = await apiClient.put<User>(`/staff/${id}`, data);
    return response.data;
  },

  activateStaff: async (id: string) => {
    await apiClient.patch(`/staff/${id}/activate`);
  },

  deleteStaff: async (id: string) => {
    await apiClient.delete(`/staff/${id}`);
  },

  search: async (params: { page?: number; size?: number; search?: string; role?: string; active?: boolean } = {}) => {
    const { page = 0, size = 10, search, role, active } = params;
    const qs = new URLSearchParams({ page: page.toString(), size: size.toString() });
    if (search) qs.set('search', search);
    if (role) qs.set('role', role);
    if (active !== undefined) qs.set('active', String(active));
    const response = await apiClient.get<PaginatedResponse<User>>(`/staff/search?${qs}`);
    return response.data;
  },
};

export default staffService;
